import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCheck, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ALERTS } from 'src/app/common';
import { IUser } from 'src/app/models';
import { IWebUserCredential } from 'src/app/models/i-web-user-credential';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  modalReference: NgbModalRef;
  users: IUser[];

  user: IUser;
  webUserCredential: IWebUserCredential;

  userForm: FormGroup;
  webUserCredentialForm: FormGroup;
  checkUserPass: boolean;
  checkRegistroNacionalPass: boolean;
  
  constructor(
    private userService: UserService,
    private alertsService: AlertsService,
    private blockUiService: BlockUiHandlerService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    library: FaIconLibrary
    ) {
      library.addIcons(faCheck, faTimes, faEdit)
    }

  ngOnInit(): void {
    this.InitVariables();
  }

  InitVariables(): void {
    this.ResetUserForm();
    this.ResetWebUserCredentialForm();
    this.LoadData();
  }

  LoadData(): void {
    this.LoadUsers();
  }

  StoreUser(): void {
    let User = this.userForm.value as IUser;
    let WebUserCredential = this.webUserCredentialForm.value as IWebUserCredential;
    if(this.checkUserPass && User.Password === '') {
      this.alertsService.ShowBigCenteredAlert("La contraseña de usuario esta requerida, desmarquela si no desea guardarla", 3);
    } else if(this.checkRegistroNacionalPass && WebUserCredential.RegistroNacionalPass === ''){
      this.alertsService.ShowBigCenteredAlert("La contraseña del Registro Nacional esta requerida, desmarquela si no desea guardarla", 3);
    } else {
      this.blockUiService.Start(1, 'Guardando usuario...');
      this.userService.StoreUser(User).subscribe(req0 => {
        if (req0.Result) {
          WebUserCredential.UserId = req0.Data
          this.userService.StoreWebUserCredential(WebUserCredential).subscribe(req1 => {
            this.blockUiService.Stop();
            if(req1.Result){
              this.CloseModal();
              this.alertsService.ShowSmallCornerAlert(`Usuario guardado`, ALERTS.success);
              this.LoadUsers();
            } else {
              this.alertsService.ShowBigCenteredAlert(`Error: ${req1.ErrorInfo.Message}`, ALERTS.error);
            }
          }, err => {
            this.blockUiService.Stop();
            this.alertsService.ShowBigCenteredAlert(`Error: ${err}`, ALERTS.error);
          })
        }
        else {
          this.blockUiService.Stop();
          this.alertsService.ShowBigCenteredAlert(`Error: ${req0.ErrorInfo.Message}`, ALERTS.error);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertsService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
      });
    }
  }

  NewUser(content: any): void{
    this.user = null;
    this.ResetUserForm();
    this.ResetWebUserCredentialForm();
    this.RaiseUserModal(content);
  }

  RaiseUserModal(content): void {
    this.modalReference = this.modalService.open(
      content, 
      {
        centered: true,
        backdrop: 'static',
        size: 'lg'
      }
    );
  }

  CloseModal(): void {
    this.modalReference.close();
  }

  ResetUserForm(): void {
    this.checkUserPass = false;
    this.userForm = this.formBuilder.group({
      Id: [-1],
      Email: ['', Validators.required],
      Password: [''],
      Active: [true, Validators.required]
    });
  }

  ResetWebUserCredentialForm(): void {
    this.checkRegistroNacionalPass = false;
    this.webUserCredentialForm = this.formBuilder.group({
      Id: [-1],
      UserId: [-1],
      RegistroNacionalUser: [''],
      RegistroNacionalPass: [''],
      Active: [true, Validators.required]
    });
  }

  LoadUsers(): void {
    this.blockUiService.Start(1, "Cargando usuarios...")
    this.userService.GetUsers().subscribe(req => {
      this.blockUiService.Stop();
      if (req.Result) {
        this.users = req.Data;
      }
      else {
        this.alertsService.ShowSmallCornerAlert(`Error: ${req.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertsService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  GetUserById(Id: number, content: any): void {
    this.userService.GetUserById(Id).subscribe(req0 => {
      if (req0.Result) {
        this.ResetUserForm();
        this.user = req0.Data;
        this.userForm.patchValue({
          ...this.user
        });
        this.userService.GetWebUserCredential(Id).subscribe(req1 => {
          if(req1.Result){
            this.ResetWebUserCredentialForm();
            this.webUserCredential = req1.Data;
            this.webUserCredentialForm.patchValue({
              ...this.webUserCredential
            });
          } else {
            this.alertsService.ShowSmallCornerAlert(`Error: ${req1.ErrorInfo.Message}`, ALERTS.warning);
          }
          this.RaiseUserModal(content);
        }, err => {
          this.alertsService.ShowSmallCornerAlert(`Error: ${err}`, ALERTS.warning);
        })
      }
      else {
        this.alertsService.ShowSmallCornerAlert(`Error: ${req0.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.alertsService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  CheckUserPass(){
    if(this.checkUserPass) 
      this.userForm.controls['Password'].setValue('');
    this.checkUserPass = !this.checkUserPass;
  }

  CheckRegistroNacionalPass(){
    if(this.checkRegistroNacionalPass) 
      this.webUserCredentialForm.controls['RegistroNacionalPass'].setValue('');
    this.checkRegistroNacionalPass = !this.checkRegistroNacionalPass;
  }

}
